import React from 'react';
import "leaflet/dist/leaflet.css";
import { TileLayer } from 'react-leaflet';
import { convertImageColors } from '../../../utils/map';

const CustomTileLayer = ({maxZoom=9, minZoom=2}) => {
  const tileCache = {}

  const handleTileLoad = (event) => {
    const { x, y, z } = event.coords;
    if (tileCache[`${z},${x},${y}`]) return;
    tileCache[`${z},${x},${y}`] = true

    const darkHex = '#00239C'
    const primaryHex = '#009CDE'
    const targetHex = '#AFD7E1'

    const tile = event.tile;
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    canvas.width = tile.width;
    canvas.height = tile.height;
    context.drawImage(tile, 0, 0);

    // Apply a color filter to the canvas
    const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
    convertImageColors(imageData, { primary: primaryHex, dark: darkHex, target: targetHex });
    context.putImageData(imageData, 0, 0);
    tile.src = canvas.toDataURL();
    canvas.remove();
  }

  const handleTileUnload = (event) => {
    const { x, y, z } = event.coords;
    tileCache[`${z},${x},${y}`] = false
  }

  return <TileLayer
    className='map-tiles'
    url={`https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png?v=${Date.now()}`}
    noWrap={true}
    maxZoom={maxZoom}
    minZoom={minZoom}
    crossOrigin="anonymous"
    eventHandlers={{ tileload: handleTileLoad, tileunload: handleTileUnload }}
  />
}

export default CustomTileLayer;